import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-photo-galary',
  templateUrl: './photo-galary.component.html',
  styleUrls: ['./photo-galary.component.css']
})
export class PhotoGalaryComponent implements OnInit {

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;

  Action:string="Create"
  AlbumPhoto:string[] = []; 
  TempAlbumPhoto:any; 
  PhotoAlbumTitleList:any;
  PhotoList:any;
  PhotoPath:any;
  
  imageurls =[];
  base64String: string;

  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
    viewsimage(item){
this.PhotoPath=item.PhotoPath;
    }
  PhotoAlbumModel = {
    PhotoAlbumTitleID:0,
    PhotoAlbumTitle: '',
}


removeImage(i) {
  this.imageurls.splice(i, 1);
}
getFileDetails(event) {
  if (event.target.files && event.target.files[0]) {
    var filesAmount = event.target.files.length;
    for (let i = 0; i < filesAmount; i++) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageurls.push({ base64String: event.target.result, });
      }
      reader.readAsDataURL(event.target.files[i]);
    }
  }
}
 
SaveAlbumPhoto() {

  this.spinnerService.show();

    this.adminservice.SaveAlbumPhoto(JSON.stringify(this.PhotoAlbumModel),JSON.stringify(this.imageurls)).subscribe((data: any) => {    
    
      this.spinnerService.hide();
      this.GetAllAlbumTitle();
      this.globalHelper.CheckActionStatus(data);   
         
      this.imageurls.splice(0);
    });    
};


SaveAlbumTitle() {
  this.spinnerService.show();
    this.adminservice.SaveAlbumTitle(JSON.stringify(this.PhotoAlbumModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
        if (data.webResponse.Status && this.PhotoAlbumModel.PhotoAlbumTitleID == 0) {
            this.Reset();
        }
        if (data.webResponse.Status) {                   
            this.GetAllAlbumTitle();
        }               
    });
};


GetAllAlbumTitle() {
  this.spinnerService.show();
    this.adminservice.GetAllAlbumTitlePhoto().subscribe((data: any) => {
        this.PhotoAlbumTitleList = data.PhotoDetails;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
    });
};

Edit(item) {
    this.Action = 'Edit';
    this.PhotoAlbumModel.PhotoAlbumTitleID = item.PhotoAlbumTitleID;
    this.PhotoAlbumModel.PhotoAlbumTitle = item.PhotoAlbumTitle;
}

Reset() {
    this.PhotoAlbumModel.PhotoAlbumTitleID = 0;
    this.PhotoAlbumModel.PhotoAlbumTitle = '';
    this.Action = 'Create';
}


Delete() {
    this.PhotoList = [];
    for (var j = 0; j < this.PhotoAlbumTitleList.length; j++) {
        for (var i = 0; i < this.PhotoAlbumTitleList[j].PhotoAlbulList.length; i++) {
            if (this.PhotoAlbumTitleList[j].PhotoAlbulList[i].IsActive == true) {
                var model = {
                    PhotoID: this.PhotoAlbumTitleList[j].PhotoAlbulList[i].PhotoID
                }
                this.PhotoList.push(model);
            }
        }
    }

    this.spinnerService.show();
    this.adminservice.DeleteAlbumPhoto(JSON.stringify(this.PhotoList)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
        this.GetAllAlbumTitle();
    });
}


Set(item) {   
    this.PhotoAlbumModel.PhotoAlbumTitleID = item.PhotoAlbumTitleID;
    this.PhotoAlbumModel.PhotoAlbumTitle = item.PhotoAlbumTitle;
}

  ngOnInit() {
    this.GetAllAlbumTitle();
  }

}
